<template>
  <h1 class="text-center">Heros</h1>
</template>

<script>
export default {
  name: "Heros"
}
</script>

<style scoped>

</style>